<!-- The popup that informs the user about the requirements of validation and whether they are met or not -->
<template>
	<div data-validation-popup v-if="validationShouldBeShown" :data-layout-width="layout.LayoutWidth">
		<span data-close-popup-icon
			v-on:click.prevent="closeValidationPopup()"
			v-on:keydown.enter.prevent="closeValidationPopup()"
			:arial-label="$store.getters.textResource(`rs_validation_popup_close`)"
			role="button"
			tabindex="0"
		> 
			<font-awesome-icon icon="times-circle" />
		</span>
		<div v-if="hasBackendMessage" data-correct-input="false">
			<span data-bubble>
				<font-awesome-icon icon="exclamation" />
			</span>
			<span data-text aria-live="assertive">
				{{ $store.state.message[0].text }}
			</span>
		</div>
		<div
			v-else
            v-for="(rule, index) in allValidation"
            :key="`rule-${index}`"
            :data-correct-input="rule.isValid.toString()"
        >
			<span v-if="rule.isValid === true" data-bubble>
				<font-awesome-icon icon="check-circle" />
			</span>
			<span v-else-if="rule.isValid === false" data-bubble>
				<font-awesome-icon icon="exclamation" />
			</span>
			<span data-text aria-live="assertive">
				{{ validationTypeText(rule.validationType) }}
			</span>
			<span v-if="rule.value" data-bubble aria-live="assertive">
				{{ rule.validationType === "requiredPoints" ? 0 : rule.value }}
			</span>
		</div>	
	</div>
</template>

<script>
export default {
	name: `validation-popup`,
	props: {
		// The validation that is automatically calculated in mixins.js
		questionValidation: {
			type: Array,
			required: true,
		},
		// Questions can add some extra validation if this is needed. This should only be used if as a last resort
		customValidation: {
			type: Array,
			default: function () {
				return [];
			}
		}
	},
	methods: {
		validationTypeText: function (type) {
			let stringName = ``;

			switch (type) {
				case `none`:
					stringName = `rs_question_is_required`;
					break;
				case `minValue`:
					stringName = `rs_min_answers`;
					break;
				case `maxValue`:
					stringName = `rs_max_answers`;
					break;
				case `requiredPoints`:
					stringName = `rs_should_be`;
					break;
			}

			return this.$store.getters.textResource(stringName);
		},
		closeValidationPopup() {
			this.$store.commit(`changeGlobal`, {
                variableName: `showValidationPopup`,
                newValue: false,
            });
		}
	},
	computed: {
		// These are validation messages that come from the back-end
		hasBackendMessage: function () {
			return this.$store.state.message?.length > 0;
		},
		layout: function () {
			return this.$store.state.layout;
		},
		allValidation: function () {
			return Array.from(this.questionValidation).concat(this.customValidation);
		},
		// Decide on whether the validation should be shown
		validationShouldBeShown: function () {
			let aRuleIsInvalid = this.allValidation.some((r) => r.isValid === false);
			if(this.$store.state.message && this.$store.state.message.length > 0) {
				return true;
			}
			else if(this.$store.state.global.showValidationPopup === false) {
				return false;
			}		
			else {
				// Only when the next button has been clicked, or if the server has returned a validation message
				return aRuleIsInvalid && (this.$store.state.global.nextButtonClicked || (this.hasBackendMessage && this.hasBackendMessage.length > 0));
			}	
		}
	},
};
</script>

<style scoped>
@import "./../styles/variables.css";

[data-validation-popup] {
	position: absolute;
	top: 0;
	right: -250px;
	background: white;
	box-shadow: 0 5px 8px #ccc;
	border-radius: 5px;
	padding: 22px 30px;
	transition: 1s;
	z-index: 1;

	max-width: 400px;

	& > div {
		position: relative;

		&:not(:first-of-type) {
			margin-top: 15px;
		}

		&:not(:last-of-type) {
			margin-bottom: 15px;
		}
	}
}

[data-validation-popup][data-layout-width="Large"] {
	right: -100px;
}

span[data-bubble] {
	min-width: 28px;
	padding: 5px;
	height: 26px;
	border-radius: 2px;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: -4px;
	border-radius: 5px;

	&:first-of-type {
		left: -44px;
	}

	&:last-of-type {
		right: -44px;
	}
}
span[data-close-popup-icon] {
	top: -21px;
    right: -18px;
	cursor: pointer;
    position: absolute;
    min-width: 44px;
    min-height: 44px;
    padding: 5px;
    height: 26px;
    align-items: center;
    display: flex;
    justify-content: center;
	svg {
		font-size: 25px;
		color: var(--primary-color);
	}
}

[data-text] {
	font-size: 15px;
	transition: 0.7s;
	display: inline-block;
	width: 100%;

	&:first-letter {
		text-transform: capitalize;
	}
}

i,
[data-bubble] {
	font-weight: bold;
	color: #fff;
	font-size: 18px;
	transition: 0.7s;
}

[data-correct-input="false"] {
	[data-bubble] {
		background: #da291c;
		svg {
			font-size: 15px;
		}
	}
}

[data-correct-input="true"] {
	[data-bubble] {
		background: #88dc3f;
	}
}

[data-correct-input="neutral"] {
	[data-bubble] {
		background: var(--primary-color);
	}
}

@media only screen and (max-width: 1500px) {
	[data-validation-popup] {
		right: 10px;
		top: 20px;
		border: 1px solid #ccc;
	}
}
</style>